import "./css/Tillfällig.css";
import logga from "../assets/logga.png";

function ComingSoon() {
    return (
        <div className="coming-soon"
        
        >
            <img
                src={logga}
                alt="Gudfadderiet"
                className="logga"
            />
        
            <h1>Inte ens tiden väntar för evigt.</h1>
            <h1>Timglaset har vänts...</h1>
            <p>Varje sekund tar oss närmare <span className="viking-font">N0lle-P</span>.</p>
            <p>Vi ses snart, <span className="viking-font">N0llan</span>.</p>
        </div>
    );
}

export default ComingSoon;